import api from './api'

const aboutService = {
  getAboutContent: async () => {
    const response = await api.get('/about')
    return response.data
  },

  getTeamMembers: async () => {
    const response = await api.get('/about/team')
    return response.data
  },

  createTeamMember: async (data) => {
    const response = await api.post('/about/team', data)
    return response.data
  },

  updateTeamMember: async (id, data) => {
    const response = await api.put(`/about/team/${id}`, data)
    return response.data
  },

  deleteTeamMember: async (id) => {
    const response = await api.delete(`/about/team/${id}`)
    return response.data
  },
}

export default aboutService
